// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"27":"9716df3f","522":"d693ceb7","594":"defdb3ef"}[chunkId] + ".js";
};